import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=929503ce&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=js&"
export * from "./orderList.vue?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=929503ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../cache/node/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929503ce",
  null
  
)

export default component.exports